import { AbstractControl } from '@angular/forms';

export class ConfirmPasswordValidator {
	/**
	 * Check matching password with confirm password
	 * @param control AbstractControl
	 */
	static MatchPassword(control: AbstractControl) {
		const password = control.get('password')?.value;
		const confirmPasswordControl = control.get('confirmPassword');
		const confirmPassword = confirmPasswordControl?.value;
		if (!confirmPassword) {
			return null;
		}
		if (password !== confirmPassword) {
			confirmPasswordControl.setErrors({ ConfirmPassword: true });
		} else {
			const errors = confirmPasswordControl.errors;
			if (errors) {
				delete errors['ConfirmPassword'];
				if (Object.keys(errors).length === 0) {
					confirmPasswordControl.setErrors(null);
				} else {
					confirmPasswordControl.setErrors(errors);
				}
			}
		}
	}
}
